module.exports = __webpack_public_path__ + "static/media/chat.d0a98e20.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/chat.svg
// module id = 172
// module chunks = 0